/**
 * Date-extensions locale German (Switzerland) [de-ch]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('de-ch', {
    monthNames: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    monthShortNames: ['Jan.','Febr.','März','April','Mai','Juni','Juli','Aug.','Sept.','Okt.','Nov.','Dez.'],
    dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
    dayShortNames: ['So','Mo','Di','Mi','Do','Fr','Sa']
});
